const MIN_LOADER_VISIBLE_MS = 1500;

function loaderElapsedMs(): number {
	const startedAt = window.__groinLoaderStarted ?? performance.now();
	return Math.max(0, performance.now() - startedAt);
}

export function hideGlobalSpinner(document: Document): void {
	const spinner = document.getElementById('app-global-spinner');
	if (!spinner || spinner.classList.contains('is-hidden')) {
		return;
	}

	const hide = () => {
		spinner.classList.add('is-hidden');
		spinner.setAttribute('hidden', '');
	};

	const runHide = () => {
		const finalize = document.defaultView?.finalizeAppGlobalSpinner;
		if (typeof finalize === 'function') {
			finalize(hide);
			return;
		}

		hide();
	};

	const remaining = MIN_LOADER_VISIBLE_MS - loaderElapsedMs();
	if (remaining > 0) {
		window.setTimeout(runHide, remaining);
		return;
	}

	runHide();
}
